















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { Prop } from 'vue-property-decorator'
import { TicketResourceModel } from '@/modules/ticket/models/ticket-resource.model'
import { VipGroupResourceModel } from '@/modules/vip-group/models/vip-group-resource.model'
import { VipGroupCreateUseCase } from '@/modules/vip-group/use-cases/admin/vip-group-create.use-case'
import AdminVipGroupCreateDialog from '@/modules/vip-group/components/admin/AdminVipGroupCreateDialog.vue'

@Component({
  components: {
    BaseButton
  }
})
export default class AdminVipGroupCreateButton extends Vue {
  constructor(
    private readonly vipGroupCreateUseCase: VipGroupCreateUseCase
  ) {
    super()
  }

  @Prop({ default: 'جدید' }) label?: string
  private dialog = null
  private vipGroup: VipGroupResourceModel = this.initData()

  openDialog() {
    this.vipGroup = this.initData()
    this.dialog = this.$q.dialog({
      component: AdminVipGroupCreateDialog,
      label: 'ایجاد گروه جدید',
      isLoading: this.vipGroupCreateUseCase.isLoading,
      vipGroup: this.vipGroup
    }).onOk((request: TicketResourceModel) => {
      this.onSubmit(request)
    })
  }

  onSubmit(request) {
    this.dialog.update({ isLoading: true })
    this.vipGroupCreateUseCase.execute(request)
      .then(() => {
        if (this.vipGroupCreateUseCase.isSuccess) {
          this.dialog.hide()
        }
        this.dialog.update({ isLoading: false })
      })
  }

  initData(): VipGroupResourceModel {
    return {
      active: false,
      created_at: '',
      description: '',
      id: 0,
      percent: 0,
      title: '',
      updated_at: '',
      users: []
    }
  }

}
